<template>
  <div class="phone">
    <div class="u-flex" v-if="isShow">
      <div class="phone-text" style="">{{ hidPhone }}</div>
      <div class="pot" @click="isShow = false">
        <!-- <Icon size="20" type="ios-eye" /> -->
        <img src="@/assets/images/preiew/close.svg" class="icona" />
      </div>
    </div>
    <div class="u-flex" v-else>
      <div class="phone-text">{{ phone }}</div>
      <div class="pot" @click="isShow = true">
        <img src="@/assets/images/preiew/open.svg" class="icona" />
        <!-- <Icon type="ios-eye-off" size="20"  /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["phone"],
  watch: {
    phone: {
      deep: true,
      immediate: true,
      handler: function (arr) {
        console.log('phone', arr);
        this.hidePhoneNumber(arr);
      },
    },
  },
  data() {
    return {
      hidPhone: "",
      isShow: true,
    };
  },
  methods: {
    hidePhoneNumber(phoneNumber) {
      // 检查是否是11位手机号
      // if (phoneNumber.length !== 11) {
      //   console.error("Invalid phone number. Please enter an 11-digit number.");
      //   return phoneNumber;
      // }

      // 隐藏手机号中间部分
      const visiblePart = phoneNumber.slice(0, 3);
      const hiddenPart = "*".repeat(4);
      const lastPart = phoneNumber.slice(-4);
      this.hidPhone = `${visiblePart}${hiddenPart}${lastPart}`;
      // 返回隐藏后的手机号
    },
  },
};
</script>
<style lang="less">
.phone {
  display: flex;
}
.phone-text {
  width: 92px;
  margin-right: 5px;
}
.icona {
  position: relative;
  top: 2px;
  width: 20px;
  height: 20px;
}
</style>
